import { render } from "./PressView.vue?vue&type=template&id=59fcc04c"
import script from "./PressView.vue?vue&type=script&lang=js"
export * from "./PressView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__